import { useReplacePhoneNumberModalStore } from "@forwardflow/store/modal";
import { Button } from "@forwardflow/ui";
import { Modal } from "antd";

export const ReplacePhoneNumberModal = () => {
  const { isReplacePhoneNumberModalOpen, closeReplacePhoneNumberModal } =
    useReplacePhoneNumberModalStore();
  return (
    <>
      <Modal
        className="ff-modal"
        title="Replace numbers Permanently"
        open={isReplacePhoneNumberModalOpen}
        onCancel={closeReplacePhoneNumberModal}
        footer={null}
      >
        <p className="mt-5 mb-14">
          Forward Flow will automatically replace these numbers with new numbers
          from their respective area codes once the active conversations end.
        </p>
        <Button className="w-full h-12 font-semibold transition-all border !rounded">
          Auto Replace
        </Button>
        <button
          onClick={closeReplacePhoneNumberModal}
          className="w-full h-12 mt-2 font-semibold transition-all border rounded border-white/20 hover:bg-white/10"
        >
          Cancel
        </button>
      </Modal>
    </>
  );
};
